module.exports = __webpack_public_path__ + "static/media/clubs_4.ed04586d.png";